import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircle from '@mui/icons-material/AccountCircle';

interface AdminHeaderProps {
  email?: string;
  onLogout: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ email, onLogout }) => (
  <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 4 }}>
    {email && (
      <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
        <AccountCircle sx={{ mr: 1 }} />
        <Typography variant="body1">{email}</Typography>
      </Box>
    )}
    <Button
      variant="outlined"
      color="error"
      startIcon={<LogoutIcon />}
      onClick={onLogout}
      sx={{ fontWeight: 700 }}
    >
      Logout
    </Button>
  </Box>
);

export default AdminHeader; 